import o from "./identity.js";
import e from "./_overRest.js";
import i from "./_setToString.js";
function n(t, r) {
  return i(e(t, r, o), t + "");
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseRest.js
// module id = 1490
// module chunks = 67